module.exports = __webpack_public_path__ + "img/1.628de627.png";